export default "__VITE_ASSET__Xj0JAYhI__";